module.exports = __webpack_public_path__ + "img/bell.f0b152f.svg";